import { Box, IconButton, Stack, TableCell, TableRow } from '@mui/material'
import React from 'react'
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';


const ReadOnlyRowMoverAdd = ({ row, setProdSel, setEditRowId, handleDelete}) => {

    const handleDeleteClick = (event, row) => {
        event.preventDefault();
        setEditRowId(null);
        handleDelete(row);
    }
    
    const handleEditClick = (event, row) => {
        event.preventDefault();
        setEditRowId(row.id);
    }

    return (
        <TableRow key={row.id}>
            <TableCell key={row.id + '_id'} align='left'>{row.id}</TableCell>
            <TableCell key={row.id + '_codbar'} align='left'>
                <Box sx={{width: '100px'}}>
                    {row.codBar}
                </Box>
            </TableCell>    
            <TableCell key={row.id + '_prod'} align='left'>
                <Box sx={{width: '220px'}}>
                    {row.product}
                </Box>
            </TableCell>    
            <TableCell key={row.id + '_price'} align='right'>{Number(row.price).toFixed(2)}</TableCell>
            <TableCell key={row.id + '_qty'} align='right'>
                <Box sx={{width: '80px'}}>
                    {row.cantidad}
                </Box>
            </TableCell>
            <TableCell key={row.id + '_tot'} align='right'>{Number(row.total).toFixed(2)}</TableCell>
            <TableCell key={'controles_' + row.id} align='left'>
                <Stack direction='row' spacing={0}>
                    <IconButton color="primary" aria-label="edit" onClick={(event) => handleEditClick(event, row)}>
                        <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton sx={{ color: 'red' }} aria-label="edit" onClick={(event) => handleDeleteClick(event, row)}>
                        <DeleteIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </TableCell>
        </TableRow>
    )
}

export default ReadOnlyRowMoverAdd